module.exports = __webpack_public_path__ + "img/Discover.223fb9dc.png";